export default __webpack_public_path__ + "static/media/sashidashihyo.5e806fcf.jpg";